import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'whatwg-fetch'
import 'promise-polyfill/src/polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk';
import data from './reducer'
import App from './components/App'
import ReactTestUtils from 'react-dom/test-utils';

window.ReactTestUtils = ReactTestUtils;

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(data, composeEnhancers(
  applyMiddleware(thunk)
));

const marquee_banner = document.querySelector('#marquee_banner')
ReactDOM.render(<Provider store={store}><App /></Provider>, marquee_banner)
